module.exports = __webpack_public_path__ + "static/media/shader.5d8d0658.frag";


//////////////////
// WEBPACK FOOTER
// ./src/lib/vendor/postprocessing/materials/glsl/dot-screen/shader.frag
// module id = 280
// module chunks = 0